import React, { useEffect, useState, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import { isImzFlowType, isRxFlowType } from '../../../common/utils';
import './TermsLimitationsModal.scss';
import { heroTextSelector } from '../../../common/selectors';
import TermsLimitationText from './TermsLimitationText';
import { disclaimerText } from '../../../services/disclaimerText';
import LoadingComponent from '../../../common/components/LoadingComponent';

const specificBannersForDisclaimer = [
  'Jewel-Osco',
  'Acme',
  'Albertsons',
  'Randalls',
  'Tom Thumb',
  'Safeway',
  'Pavilions',
  'Vons',
  'Haggen',
  'Carrs',
  'Star Market',
  'Shaws',
];

const TermsLimitationsModal = ({
  termsLimitationsModalShow,
  handleTermsLimitationsClose,
}) => {
  const closeButtonRef = useRef(null);
  const [disclaimerArray, setdisclaimerArray] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFlag, setIsLoadingFlag] = useState(false);

  const [loadingMessage, setLoadingMessage] = useState('');
  const heroText = useSelector(heroTextSelector);
  useEffect(() => {
    if (termsLimitationsModalShow) {
      setIsLoading(true);
      setLoadingMessage('loading..');

      const obj = {
        flowType:
          isImzFlowType && !isRxFlowType ? 'immunization' : 'prescription',
        bannerName: specificBannersForDisclaimer.includes(heroText)
          ? heroText
          : 'others',
      };

      disclaimerText(obj)
        .then((res) => {
          setdisclaimerArray(JSON.parse(res.response.data.data));
          setIsLoading(false);
          setIsLoadingFlag(true);
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  }, [termsLimitationsModalShow]);

  useEffect(() => {
    if (termsLimitationsModalShow) {
      const handleKeyDown = (event) => {
        if (
          event.keyCode === 9 &&
          document.activeElement === closeButtonRef.current
        ) {
          event.preventDefault();
        }
      };
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
    return () => {};
  }, [termsLimitationsModalShow]);

  return (
    <div className="termslimitation-wrapper">
      <LoadingComponent isLoading={isLoading} loadingMessage={loadingMessage} />
      {isLoadingFlag ? (
        <>
          {' '}
          <Modal
            show={termsLimitationsModalShow}
            onHide={handleTermsLimitationsClose}
            backdrop="static"
            keyboard={false}
            centered
            size="lg"
            aria-label="terms-and-limitations"
            aria-modal="true"
            className="Terms-Limitations-Text-wrapper mb-3"
          >
            <TermsLimitationText disclaimerArray={disclaimerArray} />

            <div className="d-grid button-close">
              <Button
                ref={closeButtonRef}
                id="nextCommunication"
                className="Close-button GA4_CTA popup-close-button"
                variant="secondary"
                size="lg"
                aria-label="close"
                cta_type="Pharmacy Incentives"
                onClick={handleTermsLimitationsClose}
                data-testid="terms-conditions-close"
              >
                Close
              </Button>
            </div>
          </Modal>
        </>
      ) : (
        ''
      )}
    </div>
  );
};
TermsLimitationsModal.propTypes = {
  termsLimitationsModalShow: PropTypes.bool,
  handleTermsLimitationsClose: PropTypes.func,
};

export default TermsLimitationsModal;
